var viewer_caption_rtlignore_default = {
  "fontElementMap": "AwnIM",
  "imageCaption": "ch2rA"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
